<div class="login_form">

    <div class="logo">
        <img src="../../../../../assets/images/logo/flowtrics_logo.png">
    </div>

    <div class="title">UPDATE YOUR PASSWORD</div>

    <form name="loginForm" class="fix-mat-form-field" [formGroup]="updatePasswordForm" novalidate>       
        <mat-form-field appearance="fill">
            <mat-label>New Password</mat-label>
            <input matInput [type]="hidenew ? 'password' : 'text'" placeholder="Enter new password"
                formControlName="newPassword" maxlength="30" (keyup)="Passwords()"> 
            <mat-icon matSuffix (click)="hidenew = !hidenew" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidenew">{{hidenew ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-hint class="errorpass">Choose a password of at least eight characters,
                one uppercase, one special character, lowercase letter and one number
            </mat-hint>
            <mat-error class="errorpass">
                Password of at least eight characters with one uppercase, one special character, lowercase letter and one number
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" fxFlex>
            <mat-label>Confirm password</mat-label>
            <input matInput [type]="hideconfirm ? 'password' : 'text'" placeholder="Re-enter new password"
              maxlength="30"  (keyup)="matchPassword()" formControlName="confirmPassword">
            <span matSuffix (click)="hideconfirm = !hideconfirm" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideconfirm">
                <mat-icon>{{hideconfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
            </span>
            <!-- <mat-hint class="errorpass">Choose a password of at least eight characters,
                one uppercase, one special character, lowercase letter and one number
            </mat-hint> -->
            <mat-error class="errorpass">
                Password does not match
            </mat-error>
        </mat-form-field>

        <!-- [disabled]="updatePasswordForm.invalid" -->

        <button mat-raised-button class="submit-button" aria-label="Update Password"
        (click)="updatePassword(updatePasswordForm.value)"
        [disabled]="!UpdatePassword"
            color="primary">Update Password</button>
      
    </form>


    
</div>

<app-loader></app-loader>